// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fa-0";
export var actionModalContentContainer = "_fa-1";
export var createTagButton = "_fa-2";
export var footerContainer = "_fa-7";
export var fullWidthDivider = "_fa-3";
export var hasCreateTagButton = "_fa-4";
export var noCreateTagButton = "_fa-5";
export var tagsContainer = "_fa-6";
export var tagsModalContentContainer = "_fa-8";